import { ModalState } from "./types"

export const initialModalState: ModalState = {
	name: '',
	context: undefined
}
